import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Skeleton,
  Typography,
  Alert,
} from "@mui/material";
import Breadcrumbs from "components/common/Breadcrumbs";
import { Link as RouterLink } from "react-router-dom";
import useHome from "hooks/home/useHome";
import { surfacePanelSx } from "constants/pageSurfaces";

function StatCard({
  title,
  value,
  to,
}: {
  title: string;
  value: number | string;
  to: string;
}) {
  return (
    <Card variant='outlined' sx={{ height: '100%', bgcolor: '#ffffff' }}>
      <CardActionArea component={RouterLink} to={to} sx={{ height: '100%' }}>
        <CardContent>
          <Typography color='text.secondary' variant='body2' gutterBottom>
            {title}
          </Typography>
          <Typography variant='h4' component='div' fontWeight='bold'>
            {value}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

export default function Dashboard() {
  const { home, isLoading, isError } = useHome();

  return (
    <div>
      <Box>
        <Breadcrumbs
          data={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Overview' }]}
        />
      </Box>
      <Typography variant='h4' mt={2} mb={2} fontWeight='bold'>
        Dashboard
      </Typography>
      {isError && (
        <Alert severity='error' sx={{ mb: 2 }}>
          Could not load dashboard data.
        </Alert>
      )}
      <Box sx={{ ...surfacePanelSx, p: 3 }}>
      <Grid container spacing={2}>
        {isLoading || !home ? (
          <>
            {[1, 2, 3].map((i) => (
              <Grid item xs={12} sm={6} md={4} key={i}>
                <Skeleton variant='rounded' height={120} />
              </Grid>
            ))}
          </>
        ) : (
          <>
            <Grid item xs={12} sm={6} md={4}>
              <StatCard title='Pickups' value={home.pickupsCount} to='/pickups' />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <StatCard title='Work orders' value={home.ticketsCount} to='/work_orders' />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <StatCard title='Locations' value={home.locationsCount} to='/locations' />
            </Grid>
          </>
        )}
      </Grid>
      </Box>
    </div>
  );
}
